import {DDQ_DROPDOWN_CHANGE} from '../Redux.constants';

export const selectDropdownOption = (params) => ({
  type: DDQ_DROPDOWN_CHANGE,
  payload: params,
});
